"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedState = void 0;
const react_1 = require("react");
/**
 * Hook to manage a value in a debounced manner
 * @param initialValue The initial object value
 * @param debounceTimeout The debounce cooldown time in ms
 * @returns An object that holds data about the debounced entity
 */
const useDebouncedState = (initialValue, debounceTimeout) => {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [debouncedValue, setDebouncedValue] = (0, react_1.useState)(initialValue);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => setDebouncedValue(value), debounceTimeout);
        return () => clearTimeout(timeout);
    }, [debounceTimeout, value]);
    return {
        /** The current actual (non-debounced) value */
        value,
        /** Updates the current value */
        setValue,
        /** The debounced value */
        debouncedValue,
        /** Updates the debounce value immediately */
        setDebouncedValue,
    };
};
exports.useDebouncedState = useDebouncedState;
//# sourceMappingURL=use-debounced-state.js.map